/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener("DOMContentLoaded", function () {

  // 	const prodictGridItem = document.querySelectorAll(".js-productItem-wrapper");

  //       prodictGridItem.forEach(function (item, index) {
  //         item.addEventListener("mouseover", function (e) {
  //           	console.log(e.target);
  //         });
  //       });
  document.querySelectorAll('.customColor__link').forEach((link) => {
    link.addEventListener("click", function (e) {
      let url = link.getAttribute('href');
      window.location.href = "https://www.roohcollective.com/"+url;
    });
  });
 

  let viewportWidth = window.innerWidth;

  if(viewportWidth <= 768){

    document.addEventListener("click", function (e) {
	
      const parentNode = e.target.parentNode 
      if (parentNode.classList.contains("footer-list")) {
        parentNode.classList.toggle('show');
      }

    });
  }

  const gridSizeSwatch = document.querySelectorAll(".js-grid-swatch");

  gridSizeSwatch.forEach(function (item, index) {
    item.addEventListener("change", function (e) {
      var variant_qty  = item.dataset.qty;
      var variant_avail= item.dataset.avail;
      var id = item.dataset.id;
     
      if(variant_qty <= 0 && variant_avail == 'true'){

        document.querySelector(".preOrder-"+id).innerHTML ='<input type="hidden" value="Pre order" name="properties[This is a]"/>';
      }
      else{
        document.querySelector(".preOrder-"+id).innerHTML ='';
      }
      item.closest('form').submit();
    });
  });

  document.addEventListener('variant:changed', function(event) {
    	
   var variantId = event.detail.variant.id;

    if(document.querySelectorAll('.PreOrder_custom').length > 0){
      const variantDropdownSelected = document.querySelector('select.product_variant_select option[value="'+variantId+'"]');
      
      var variant_qty  = variantDropdownSelected.dataset.qty;
      var variant_avail= variantDropdownSelected.dataset.avail;
      
      if(variant_qty <= 0 && variant_avail == 'true'){
        
		document.querySelector('.PreOrder_custom span').textContent="Pre-Order";
        document.querySelector('.preorderProperty').innerHTML='<input id="preorder-product" type="hidden" value="Pre order" name="properties[This is a]"/>';
      }
      else{
        document.querySelector('.preorderProperty').innerHTML='';
      }
    }
    
  });


});